import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    serverId: false,
};

const serverIdSlice = createSlice({
    name: 'serverId',
    initialState,
    reducers: {
        setServerId: (state, action) => {
            state.serverId = action.payload
        }
    }
})

export const {setServerId} = serverIdSlice.actions;
export const serverId = serverIdSlice.reducer;